import React, { useState, useEffect } from "react";

const ExpandedForm: React.FC = () => {
    const [question, setQuestion] = useState<number | null>(null);
    const [userHundreds, setUserHundreds] = useState<string>("");
    const [userTens, setUserTens] = useState<string>("");
    const [userOnes, setUserOnes] = useState<string>("");
    const [feedback, setFeedback] = useState<string | null>(null);
    const [showImage, setShowImage] = useState(false);
    const [errorHundred, setErrorHundred] = useState(false);
    const [errorTen, setErrorTen] = useState(false);
    const [errorOne, setErrorOne] = useState(false);

    // Function to generate a new random question
    const generateQuestion = () => {
        const newNumber = Math.floor(Math.random() * 900) + 100; // Random 3-digit number
        setQuestion(newNumber);
        setUserHundreds("");
        setUserTens("");
        setUserOnes("");
        setFeedback(null);
    };

    useEffect(() => {
        generateQuestion();
        document.title = "Mamas Guidance - Class One - Mathematics - Number Math - Expanded Form"; // Set page title
    }, []);

    // Function to handle user submission
    const handleSubmit = () => {
        if (question === null) return;

        const correctHundreds = Math.floor(question / 100);
        const correctTens = Math.floor((question % 100) / 10);
        const correctOnes = question % 10;

        if (
            parseInt(userHundreds) === correctHundreds &&
            parseInt(userTens) === correctTens &&
            parseInt(userOnes) === correctOnes
        ) {
            setShowImage(true);
            setFeedback(`Correct! ${question} = ${correctHundreds} hundred(s) + ${correctTens} ten(s) + ${correctOnes} one(s)`);
            setTimeout(() => {
                generateQuestion();
                setShowImage(false);
                setErrorHundred(false);
                setErrorTen(false);
                setErrorOne(false);
            }, 5000); // Move to the next question after 3 seconds
        } else {
            if (parseInt(userHundreds) != correctHundreds) {
                setErrorHundred(true);
            }
            else {
                setErrorHundred(false);
            }
            if (parseInt(userTens) != correctTens) {
                setErrorTen(true);
            }
            else {
                setErrorTen(false);
            }
            if (parseInt(userOnes) != correctOnes) {
                setErrorOne(true);
            }
            else {
                setErrorOne(false);
            }
        }
    };

    const handleHundredChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setUserHundreds(event.target.value);
    };

    const handleTenChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setUserTens(event.target.value);
    };

    const handleOneChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setUserOnes(event.target.value);
    };

    return (
        <>
            <div className="contentPart showCenter additionWord">
                {showImage ? (
                    <div className="image-container">
                        <img
                            style={{ height: '150px' }}
                            className="img-fluid"
                            src={process.env.REACT_APP_WELDONE_LINK}
                            alt="Well Done"
                        />
                    </div>
                ) : (
                    <>
                        {question && (
                            <div className="question-list expandedForm">
                                <div className="mb-4">
                                    <div className="text-center">{question}</div>
                                    <div className="text-center">=</div>
                                </div>
                                <div className="" style={{ display: "flex", flexWrap: "wrap" }}>
                                    <div className="" style={{ display: "flex", flexWrap: "wrap" }}>
                                        <span className="grid-box">
                                            <input
                                                type="number"
                                                value={userHundreds}
                                                onChange={handleHundredChange}
                                                placeholder="-"
                                                className={`form-control blank-input ${errorHundred == true ? 'error' : ''} `}
                                            />{" "} </span>
                                        <span className="grid-box">hundred(s)</span>
                                    </div>
                                    <div className="grid-box text-center">+</div>
                                    <div className="grid-box">
                                        <input
                                            type="number"
                                            value={userTens}
                                            onChange={handleTenChange}
                                            placeholder="-"
                                            className={`form-control blank-input ${errorTen == true ? 'error' : ''} `}
                                        />{" "} ten(s)
                                    </div>
                                    <div className="grid-box text-center">+</div>
                                    <div className="grid-box">
                                        <input
                                            type="number"
                                            value={userOnes}
                                            onChange={handleOneChange}
                                            placeholder="-"
                                            className={`form-control blank-input ${errorOne == true ? 'error' : ''} `}
                                        />{" "} one(s)
                                    </div>
                                </div>
                                <div className="showMiddleOfPage">
                                    <div className="mt-2  optionButton" onClick={handleSubmit}>
                                        Submit
                                    </div>
                                </div>
                            </div>
                        )}
                    </>
                )}
            </div>
        </>
    );
};

export default ExpandedForm;
